import { render, staticRenderFns } from "./YoutubeEmbedPlayer.vue?vue&type=template&id=3aa553b4&scoped=true&"
import script from "./YoutubeEmbedPlayer.vue?vue&type=script&lang=ts&"
export * from "./YoutubeEmbedPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubeEmbedPlayer.vue?vue&type=style&index=0&id=3aa553b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa553b4",
  null
  
)

export default component.exports